import { Component, Input, OnInit } from "@angular/core";
import { DataService_StudentRelease } from "../data.service";

@Component({
	selector: "caass-release-guardian-table",
	templateUrl: "./release-guardian-table.component.html",
	styleUrls: ["./release-guardian-table.component.css"],
})
export class ReleaseGuardianTableComponent implements OnInit {
	constructor(private ReleaseService: DataService_StudentRelease) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.loadGuardian();
	}

	ngOnChanges() {
		this.loadGuardian();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() PersonID: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedGuardian: any;
	lstGuardian: any = [];

	//Filter lists
	lstRelationship: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "Name", header: "Name" },
		{ field: "Relationship", header: "Relationship" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadGuardian() {
		this.loading = true;

		if (this.PersonID == undefined) {
			this.loading = false;
			return;
		}

		var result = this.ReleaseService.GuardianFullInfoGetList(this.PersonID);
		result.subscribe(
			(response) => {
				this.lstGuardian = response;

				//Load Data Filter Lists
				this.lstRelationship = Array.from(new Set(this.lstGuardian.map((item: any) => item.Relationship))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedGuardian = val.data;
	}
	onRowUnselect(val) {
		this.SelectedGuardian = null;
	}
	////////////////////////////////////////////
}
